import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconComponent } from '../icon/icon.component';
import { Attachment, MediaType, ValidationError } from '@doddly/core';
import { ConfirmDirective } from '../confirm-popover/confirm.directive';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'ly-attachments-preview',
  standalone: true,
  imports: [CommonModule, IconComponent, ConfirmDirective],
  templateUrl: './attachments-preview.component.html',
  styleUrl: './attachments-preview.component.scss',
})
export class AttachmentsPreviewComponent {
  readonly MEDIA_TYPE = MediaType;

  @Input() attachments: Attachment[] = [];
  @Input() validationErrors: ValidationError[] = [];
  @Input() disabled = false;
  @Input() isMobile = false;
  @Input() posts: FormGroup[] = [];
  @Output() delete = new EventEmitter();
  @Output() deleteFromDoddleAndPost = new EventEmitter();

  onDelete(attachment: Attachment) {
    if (this.isAttachmentUsedInPost(attachment)) {
      this.deleteFromDoddleAndPost.emit(attachment);
    } else {
      this.delete.emit(attachment);
    }
  }

  isAttachmentUsedInPost(attachment: Attachment): boolean {
    return this.posts.some((post) =>
      post.value.mediaItems.some(
        (item: Attachment) => item.id === attachment.id,
      ),
    );
  }

  isAttachmentInvalid(attachment: Attachment): boolean {
    return this.validationErrors.some(
      (error) => error.reference === attachment.name,
    );
  }

  getAttachmentErrorMessage(attachment: Attachment): string | null {
    const error = this.validationErrors.find(
      (err) => err.reference === attachment.name,
    );
    return error ? error.message : null;
  }

  getAttachmentErrorFileName(attachment: Attachment): string | null {
    const error = this.validationErrors.find(
      (err) => err.reference === attachment.name,
    );
    return error ? error.reference : null;
  }
}
